export const lumberjacque = {
  data: function () {
    return {
      someVal: ''
    }
  },
  methods: {
    remoteLog: function (level, context, message, values) {
      values = values || new Map()

      var host = 'https://k8s.hacksy-do.com/lumberjacque'
      var path = '/log'

      var payload = {
        context: context,
        logLevel: level,
        message: message,
        service: 'danno',
        values: values
      }

      $.ajax({
        url: host + path,
        type: 'POST',
        data: JSON.stringify(payload),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/clients/lumberjacque.js